<div class="form-row h6">
    {{'Systemreports.sheetingtype.desc'|translate}}
</div>
<div class="card-footer text-right" style="background-color: white;">
    <button [attr.aria-label]="''+'Systemreports.btn.generatereport'|translate" (click)="ExportSheetingTypeReport()"
        class="report-button h7" mat-button>
        <mat-icon variant="outlined" class="material-icons-outlined" class="report-icon" svgIcon="report"></mat-icon>
        {{'Systemreports.btn.generatereport'|translate}}
    </button>
</div>